import React, { useEffect } from "react";

function TextToSpeech({ speech, onEnd }) {
  const speak = (text) => {
    const utterance = new SpeechSynthesisUtterance(text);

    utterance.onend = () => {
      if (onEnd) onEnd(); // callback when speech finishes
    };

    window.speechSynthesis.cancel(); // clear any previous speech
    window.speechSynthesis.speak(utterance);
  };

  useEffect(() => {
    if (speech) speak(speech);

    // ✅ cleanup to stop speech when component unmounts or page refreshes
    const handleUnload = () => {
      window.speechSynthesis.cancel();
    };

    window.addEventListener("beforeunload", handleUnload);

    return () => {
      window.speechSynthesis.cancel();
      window.removeEventListener("beforeunload", handleUnload);
    };
  }, [speech]);

  return null; // no UI needed
}

export default TextToSpeech;
